export default "__VITE_ASSET__CYow3rHq__"